'use client';

import { ActionIcon, TextInput } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconMessage } from '@tabler/icons-react';
import { useSession } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { SyntheticEvent, useState } from 'react';

export default function PostForm() {
  const router = useRouter();
  const { data: session } = useSession();
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState('');
  const handleChange = (event) => {
    setText(event.target.value);
  };

  async function handleSubmit(e: HTMLFormElement | SyntheticEvent) {
    e.preventDefault();
    if (text === '') return;
    setLoading(true);
    const res = await fetch('/api/posts', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        content: text,
        createdAt: new Date(),
        user: {
          _id: session.user._id,
          name: session.user.name,
          image: session.user.image,
        },
      }),
    });
    if (res.ok) {
      setText('');
      router.refresh();
    } else {
      notifications.show({
        color: 'red',
        title: 'Oops!',
        message: 'Something went wrong. Please try again later',
      });
    }
    setLoading(false);
  }

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <TextInput
        name='content'
        required
        size='md'
        type='text'
        placeholder={session ? 'Spray me down 💦' : 'Login to post'}
        value={text}
        onChange={handleChange}
        disabled={!session}
        rightSection={
          <ActionIcon
            color='brand'
            variant='filled'
            loading={loading}
            disabled={!session}
            onClick={(e) => handleSubmit(e)}
            aria-label='Post'
          >
            <IconMessage size={16} stroke={1.5} />
          </ActionIcon>
        }
      />
    </form>
  );
}
